// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// using OOTB actions as much as possible
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    wishListLineIds: string[];
    groupName: string;
    isSelectAll?: boolean;
    clearOnly?: boolean;
    clearAll?: boolean;
    onComplete?: () => void;
}>;

export const DispatchSetWishListLineIsSelected: HandlerType = props => {
    const { groupName, isSelectAll, clearOnly, clearAll } = props.parameter;
    const state = props.getState();

    const value = (state as any).commonActions["selectedGroupLines"];

    let newValues = value ? { ...value } : ({} as any);
    if(clearAll) {
        newValues[groupName] = [];
    } else if (!newValues) {
        newValues = {} as any;
        newValues[groupName] = [...props.parameter.wishListLineIds];
    } else {
        let tempValues = newValues[groupName] ? [...newValues[groupName]] : [];
        props.parameter.wishListLineIds.forEach(id => {
            if (tempValues.indexOf(id) > -1) {
                if (!isSelectAll) {
                    tempValues.splice(tempValues.indexOf(id), 1);
                }
            } else if (clearOnly) {
                tempValues = [...tempValues];
            } else {
                tempValues = [...tempValues, id];
            }
        });

        newValues[groupName] = [...tempValues];
    }

    props.dispatch({
        type: "commonActionSetter/SetAction",
        payload: {
            name: "selectedGroupLines",
            value: newValues,
        },
    } as any);
};

export const ExecuteOnComplete: HandlerType = props => {
    if (props.parameter.onComplete) {
        props.parameter.onComplete?.();
    }
};

export const chain = [DispatchSetWishListLineIsSelected, ExecuteOnComplete];

const setGroupWishListLineIsSelected = createHandlerChainRunner(chain, "SetGroupWishListLineIsSelected");
export default setGroupWishListLineIsSelected;
